import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.css']
})
export class BasicInfoComponent implements OnInit {

  userProfile: any
  
  dataLoaded: boolean

  selectedImage: any

  image: any

  userProfileForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    dob: new FormControl('', [Validators.required])
  })

  constructor( private _neproseService: NeproseService, private _notification: MatSnackBar ) { }

  ngOnInit(): void {
    this.getProfile()
  }

  getProfile(){
    this._neproseService.getUserProfile().subscribe(data => {
      this.dataLoaded = true
      if(data.status){
        this.userProfile = data.user
        if(this.userProfile.profileImage){
          this.selectedImage = environment.api + '/images/' + this.userProfile.profileImage
        }
        this.userProfileForm.setValue({firstName: this.userProfile.firstName, lastName: this.userProfile.lastName, email: this.userProfile.Credential.email, dob: this.userProfile.dob})
      }
    })
  }

  fileChangeEvent(event: any): void {
    this.image = event.target.files[0]
    if(this.image){
      var filesize = Math.ceil((parseInt(this.image.size)/1024)/1024)
      if(filesize <= 8){
        this._neproseService.updateProfileImage(this.image).subscribe(data => {
          if(data.status){
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]); 
            reader.onload = (_event) => { 
              this.selectedImage = reader.result; 
            }
            this.openNotification('Profile image has been uodated!')
          }
        })
      }else{
        this.openNotification('File size exceeded! Maximum size is 2MB.')
      }
    }
  }

  updateUser(user){
    this._neproseService.updateUser(user).subscribe(data => {
      if(data.status){
        this.getProfile()
        this.openNotification('Profile has been updated!')
      }
    })
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
